// get lang strings
// import i18n from '../i18n';

export default {
  timerSettings: {
    warmup: {
      title: 'Warmup',
      slidervalues: [0, 10, 30, 60, 90, 120, 150, 180, 240, 300, 360, 420, 480],
    },
    stretching: {
      title: 'Stretching',
      slidervalues: [0, 10, 30, 60, 90, 120, 150, 180, 240, 300, 360, 420, 480],
    },
    exercises: {
      title: 'Excercises',
      slidervalues: [2, 3, 4, 5, 6, 7, 8, 9, 10],
    },
    intervals: {
      title: 'Intervals',
      slidervalues: [10, 15, 20, 25, 30, 45, 60, 90, 120, 180, 240, 300],
    },
    breaks: {
      title: 'Low Intensity / Breaks',
      slidervalues: [5, 10, 15, 20, 25, 30, 45, 60, 90, 120],
    },
    rounds: {
      title: 'Rounds',
      slidervalues: [1, 2, 3, 4, 5, 6, 7, 8],
    },
  },
  currentTimer: {
    warmup: 120,
    stretching: 180,
    exercises: 8,
    breaks: 10,
    intervals: 20,
    rounds: 2,
  },
  settingsActive: false,
};
